import $ from 'jquery'

export default function()
{
	$('a, button').on('click', function()
	{
		$(this).trigger('blur')
	})
}



/** WEBPACK FOOTER **
 ** ./source/scripts/components/click-blur.js
 **/